import { gql } from '@apollo/client';

const EPISODE_FIELDS = `
  id
  seasonNumber
  episodeNumber
  title
  overview
  airDate
  runtime
  watched
  watchedDate
`;

const SEASON_FIELDS = `
  seasonNumber
  episodeCount
  episodes {
    ${EPISODE_FIELDS}
  }
`;

const TV_SHOW_FIELDS = `
  id
  title
  overview
  posterUrl
  firstAirYear
  genres
  cast
  creator
  network
  status
  userStatus
  favorite
  rating
  review
  spoiler
  notes
  collection
  whereWatched
  updatedAt
  seasons {
    ${SEASON_FIELDS}
  }
`;

const TV_SHOW_LIST_FIELDS = `
  id
  title
  posterUrl
  firstAirYear
  genres
  cast
  creator
  network
  status
  userStatus
  favorite
  rating
  collection
  whereWatched
  updatedAt
`;

export const GET_TV_SHOWS = gql`
  query GetTVShows($first: Int, $after: String) {
    getTVShowsListPage(first: $first, after: $after) {
      nodes {
        ${TV_SHOW_LIST_FIELDS}
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_TV_SHOW = gql`
  query GetTVShow($id: ID!) {
    getTVShow(id: $id) {
      ${TV_SHOW_FIELDS}
    }
  }
`;

export const SEARCH_TV_SHOWS = gql`
  query SearchTVShows($query: String!) {
    searchTVShows(query: $query) {
      tvdbId
      title
      overview
      posterUrl
      firstAirYear
      genres
      cast
      creator
      network
      status
      seasons {
        ${SEASON_FIELDS}
      }
    }
  }
`;

export const ADD_TV_SHOW = gql`
  mutation AddTVShow($input: TVShowInput!) {
    addTVShow(input: $input) {
      ${TV_SHOW_FIELDS}
    }
  }
`;

export const UPDATE_TV_SHOW = gql`
  mutation UpdateTVShow($id: ID!, $input: TVShowInput!) {
    updateTVShow(id: $id, input: $input) {
      ${TV_SHOW_FIELDS}
    }
  }
`;

export const DELETE_TV_SHOW = gql`
  mutation DeleteTVShow($id: ID!) {
    deleteTVShow(id: $id)
  }
`;

export const SET_TV_EPISODE_WATCHED = gql`
  mutation SetTVEpisodeWatched($showId: ID!, $episodeId: ID!, $watched: Boolean!, $watchedDate: String) {
    setTVEpisodeWatched(showId: $showId, episodeId: $episodeId, watched: $watched, watchedDate: $watchedDate) {
      ${TV_SHOW_FIELDS}
    }
  }
`;
